import * as React from 'react';
import { Textarea, ValidationProps } from 'ui';
import { CodetableMetadata, CodeFieldWireKey } from '../../types-store';
import { CodetableTranslation } from '../../constants';
import { CodeItem } from 'app/area/indicator-factors/item/types-store';

interface CommentProps {
  metadata: CodetableMetadata;
  readOnly?: boolean;
  codeItem: CodeItem;
  translation: CodetableTranslation;
  validation?: { [key: string]: ValidationProps };
  onChange: (key: CodeFieldWireKey, value: string) => void;
  resetValidation: (key: CodeFieldWireKey, value: string) => void;
  clearAllValidationData?: (key: CodeFieldWireKey) => void;
}

export const Comments = (props: CommentProps) => {

  const { readOnly, codeItem, translation, validation } = props;

  const codetableKey = CodeFieldWireKey.comments;

  const onChange = (value: string) => {
    const trimmedValue = value?.trim();
    props.resetValidation(codetableKey, trimmedValue);
    props.onChange(codetableKey, trimmedValue);
    props.clearAllValidationData(codetableKey);
  };

  const currentValidation = !!validation && !!validation[codetableKey] ? validation[codetableKey] : undefined;

  return <div className="col-lg-8 col-sm-12">
    <Textarea
      componentId={codetableKey}
      readOnly={readOnly}
      label={{ text: translation.comments, required: false }}
      value={codeItem?.[codetableKey]}
      validation={currentValidation}
      onChange={onChange}
      maxLength={4000} />
  </div>;
};
